// extracted by mini-css-extract-plugin
module.exports = {"citationTypeSearchContainer":"citation-type-picker-search-container_citationTypeSearchContainer__3IU1a"};